import { useEffect, useState } from "react";
import PageTitle from "../../components/pageTitle";
import { ConfigFIeld, PageWrapper, TituloConfig } from "./styled";
import { getSessionConfig } from "../../utils/session-helper";
import { BASE_URL } from "../../utils/http-helper";

function AmbienteDev() {
  const [ configuracoesAmbiente, setConfigs ] = useState<Object>();

  useEffect(() => {
    setConfigs(getSessionConfig());
    }, []);

  return (
  <PageWrapper>
    <PageTitle titulo="Área Restrita - Ambiente de Desenvolvimento" centralizado/>

    <ConfigFIeld>
      <TituloConfig>URL Base API:</TituloConfig>
      {BASE_URL}
    </ConfigFIeld>

    <TituloConfig></TituloConfig>
    {configuracoesAmbiente
      ? Object.keys(configuracoesAmbiente).map((key) => {
        if (key === 'Configuracoes' || key === 'Logo') return <></>;
        return (
          <ConfigFIeld>
            <TituloConfig>{key}</TituloConfig>
            {(configuracoesAmbiente as any)[key]}
          </ConfigFIeld>
        );
      })
      : <></>}

    {configuracoesAmbiente
      ? (configuracoesAmbiente as ({ Configuracoes: {
        ID: number,
        Descricao: string,
        Valor: string,
      }[] })).Configuracoes.map((item) => {
        
        return (
          <ConfigFIeld>
            <TituloConfig>{item.ID}-{item.Descricao}</TituloConfig>
            {item.ID >= 5000
              ? (<>{item.Valor === '1' ? 'H' : 'Des'}ablitado</>)
              : item.Valor}
          </ConfigFIeld>
        );
      })
      : <></>}
  </PageWrapper>
  );
}

export default AmbienteDev;
